import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseStateCategoryForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Kategória Stavu Servisného Prípadu"
                     labelNew="Pridať Kategóriu Stavu Servisného Prípadu"
                     baseUrl='/service_case/service_cases_state_categories/'
                     formContent={formContent}/>
    )

}

export default ServiceCaseStateCategoryForm
